{
  "zoomControl": {
    "zoomIn": "Acercar",
    "zoomOut": "Alejar",
    "resetZoom": "Reiniciar zoom"
  },
  "roleTesting": {
    "title": "Prueba de roles",
    "testingAsLabel": "Probando como",
    "exitButton": "Salir de prueba de rol",
    "close": "Cerrar",
    "tooltipFormat": "Probando como {{role}} - Clic para cambiar"
  },
  "languageSwitcher": {
    "title": "Idioma",
    "selectLabel": "Idioma",
    "close": "Cerrar",
    "tooltip": "{{language}} - Clic para cambiar",
    "exitButton": "Salir"
  },
  "support": {
    "contactSupport": "Contactar soporte",
    "dialogTitle": "Consulta de soporte",
    "tutorialVideos": "Videos tutoriales",
    "questionLabel": "Pregunta",
    "questionPlaceholder": "Tu consulta de soporte va aquí...",
    "cancelButton": "Cancelar",
    "sendButton": "Enviar",
    "successMessage": "Gracias. Tu solicitud de soporte ha sido recibida. Nos pondremos en contacto contigo pronto."
  },
  "selectTailNumber": {
    "tailNumberLabel": "Matrícula",
    "notInRegistryShort": "Aún no está en el registro.",
    "notInRegistryLong": "Este avión aún no está en nuestro registro.",
    "requestButton": "Solicitar",
    "requestDialogTitle": "Enviar solicitud de aeronave",
    "requestDialogDescription": "Revisa los detalles a continuación y haz clic en 'Enviar solicitud' para añadir esta aeronave a nuestro registro.",
    "tailNumberFieldLabel": "Matrícula",
    "fboLabel": "FBO",
    "requestedByLabel": "Solicitado por",
    "cancelButton": "Cancelar",
    "submitRequestButton": "Enviar solicitud",
    "submitting": "Enviando...",
    "requestErrorMessage": "No se pudo enviar la solicitud. Por favor, inténtalo de nuevo.",
    "waitForCredentials": "Por favor espera mientras verificamos tus credenciales",
    "confirmationTitle": "✈️ ¡Solicitud de aeronave enviada!",
    "confirmationMessage": "Hemos recibido tu solicitud para la aeronave <strong>{{tailNumber}}</strong>. Nuestro equipo la revisará y la añadirá al registro pronto. Te notificaremos cuando esté disponible.",
    "gotItButton": "Entendido"
  },
  "splitButton": {
    "ariaLabel": "botón dividido",
    "selectStrategyAriaLabel": "estrategia de combinación"
  },
  "speedDialNav": {
    "label": "Rótulo",
    "simplifyDemo": "Demo simplificada",
    "demo": "Demo",
    "userManagement": "Gestión de usuarios"
  },
  "windDisplay": {
    "loading": "Cargando...",
    "noData": "--"
  },
  "dateRangeControl": {
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de fin",
    "next7Days": "Próximos 7 días",
    "thisWeek": "Esta semana",
    "next30Days": "Próximos 30 días",
    "next60Days": "Próximos 60 días"
  },
  "favorites": {
    "nameLabel": "Nombre",
    "saveButton": "Guardar",
    "overwriteConfirm": "Ya existe un favorito con el nombre '{{name}}'. ¿Desea sobrescribirlo?",
    "overwriteButton": "Sí, sobrescribir"
  },
  "assignTripButton": {
    "assigned": "Asignado",
    "assign": "Asignar",
    "assignTo": "Asignar a {{locationName}}",
    "assignedTo": "Asignado a {{locationName}}",
    "assignSelected": "Asignar {{count}} viajes seleccionados",
    "assignCount": "Asignar ({{count}})",
    "thisHangar": "Este hangar",
    "thisRamp": "Esta plataf.",
    "successMessage": "Asignado {{tailNumber}} a {{locationName}}",
    "bulkSuccessMessage": "Asignados {{count}} viajes a {{locationName}}",
    "errorMessage": "Error al asignar el viaje"
  },
  "layoutToolbar": {
    "tooltips": {
      "measuringTool": "Medición"
    },
    "buttons": {
      "clear": "Borrar",
      "dump": "Volcar",
      "print": "Imprimir",
      "copy": "Copiar",
      "share": "Enviar",
      "allTenants": "Todos"
    },
    "confirmations": {
      "pleaseConfirm": "Confirmar",
      "clearMultiHangar": "Esto eliminará todas las aeronaves en los hangares seleccionados.",
      "clearNuclear": "☢️ OPCIÓN NUCLEAR: Esto desasignará TODAS las aeronaves de este {{locationType}} desde el momento actual hasta el final de sus viajes. Esta acción no se puede deshacer fácilmente. ¿Está seguro?",
      "clearLocation": "Esto eliminará todas las aeronaves listadas en este {{locationType}}.",
      "clearNuclearOk": "Sí, eliminar todos los viajes (NUCLEAR)",
      "clearLocationOk": "Sí, eliminar todas las aeronaves",
      "dumpMultiHangar": "Esto eliminará todas las aeronaves de los hangares seleccionados.",
      "dumpScheduled": "Esto eliminará todas las aeronaves de este {{locationType}} durante toda la duración de su viaje.",
      "dumpLocation": "Esto moverá todas las aeronaves al frente.",
      "dumpHangarsOk": "Sí, eliminar hangares",
      "dumpScheduledOk": "Sí, eliminar de {{locationType}}",
      "dumpLocationOk": "Sí, vaciar hangar",
      "resetMultiHangar": "Esto restablecerá los hangares seleccionados al diseño de hangar para todos los inquilinos.",
      "resetLocation": "Esto restablecerá el diseño de {{locationType}} predeterminado del tenant.",
      "resetOk": "Sí, restablecer",
      "printHangarsTitle": "Imprimir hangares",
      "printHangarsCaption": "Selecciona los hangares que deseas imprimir.",
      "copyHangarsTitle": "Copiar hangares",
      "copyHangarsCaption": "Selecciona los hangares que deseas copiar."
    },
    "messages": {
      "copiedToClipboard": "Copiado al portapapeles",
      "urlCopiedToClipboard": "URL copiada al portapapeles"
    },
    "errors": {
      "failedToCopyUrl": "Error al copiar URL",
      "failedToCopyImage": "No se pudo copiar la imagen al portapapeles. La imagen puede ser demasiado grande o puede haber un problema con las imágenes de fondo.",
      "copyFailedDetailed": "Error al copiar {{locationType}} \"{{locationName}}\". Tamaño del lienzo: {{canvasWidth}}x{{canvasHeight}}. Revisa la consola del navegador para ver los registros detallados.",
      "copyFailedGeneric": "No se pudo copiar {{locationType}} al portapapeles. La imagen puede ser demasiado grande para la memoria de tu dispositivo o hubo un problema con el renderizado de la aeronave. Intenta de nuevo o revisa la consola para más detalles.",
      "multiHangarCopyFailedDetailed": "La copia multi-hangar falló. Tamaño del canvas: {{canvasWidth}}x{{canvasHeight}}. Hangares seleccionados: {{hangarCount}}. Revisa la consola del navegador para ver los registros detallados.",
      "multiHangarCopyFailedGeneric": "No se pudo copiar el diseño multi-hangar al portapapeles. La imagen puede ser demasiado grande para la memoria de tu dispositivo o hubo un problema al renderizar las aeronaves. {{hangarCount}} hangares seleccionados. Intenta seleccionar menos hangares o revisa la consola para más detalles."
    },
    "dialogs": {
      "featureNotSupported": {
        "title": "Función no disponible",
        "message": "Esta función no es compatible con Firefox. Si desea utilizarla, por favor use otro navegador.",
        "okButton": "OK"
      },
      "copyFailed": {
        "title": "Copia fallida",
        "okButton": "OK"
      }
    }
  },
  "favoritesButton": {
    "buttons": {
      "favorites": "Favoritos"
    },
    "dialogs": {
      "saveFavoriteTitle": "Guardar configuración favorita",
      "favoritesTitle": "Favoritos",
      "pleaseConfirm": "Confirmar"
    },
    "emptyState": {
      "imageAlt": "Sin favoritos",
      "message": "No hay favoritos guardados. Haz clic en el ícono \"Guardar\" para empezar a guardar tus configuraciones favoritas."
    },
    "multiHangarFavorites": {
      "buttons": {
        "use": "Usar",
        "delete": "Eliminar"
      },
      "confirmations": {
        "useText": "Eliminar todas las aeronaves de los hangares seleccionados y reemplazar con las aeronaves de '{{stackName}}'.",
        "useNote": "Nota: Las aeronaves en esta configuración guardada se moverán de otros hangares si es necesario.",
        "useOk": "Sí, restablecer",
        "deleteText": "Está a punto de eliminar '{{stackName}}' de todos los hangares seleccionados.",
        "deleteNote": "Es decir… si '{{stackName}}' está guardado para los hangares A, B, C… pero solo seleccioné A y B… entonces C mantiene su '{{stackName}}' guardado",
        "deleteOk": "Sí, eliminar favorito"
      },
      "stackColumn": "Configuración",
      "searchPlaceholder": "Buscar configuración",
      "noStack": "Sin configuración"
    },
    "singleFavorite": {
      "printSubtitle": "Favorito: {{name}}",
      "searchPlaceholder": "Buscar configuración",
      "buttons": {
        "use": "Usar",
        "delete": "Eliminar",
        "print": "Imprimir"
      },
      "confirmations": {
        "title": "Confirmar",
        "useText": "Eliminar todas las aeronaves de tu {{locationType}} actual y reemplazarlas con las aeronaves de '{{name}}'.",
        "useOk": "Sí, restablecer a esta configuración guardada",
        "deleteText": "Está a punto de eliminar {{name}}.",
        "deleteOk": "Sí, eliminar favorito"
      }
    }
  },
  "multiLocationSave": {
    "labels": {
      "name": "Nombre"
    },
    "buttons": {
      "cancel": "Cancelar",
      "save": "Guardar"
    },
    "confirmations": {
      "overwriteMessage": "Ya existe un favorito con el nombre '{{name}}'. ¿Desea sobrescribirlo?",
      "overwriteOk": "Sí, sobrescribir"
    }
  },
  "addMovableObstacle": {
    "buttonText": "Añadir obstáculo móvil",
    "dialogTitle": "Añadir obstáculo móvil",
    "cancelButton": "Cancelar",
    "doneButton": "Listo",
    "movableObstacleGrid": {
      "columns": {
        "name": "Nombre",
        "lengthFt": "Longitud (ft)",
        "widthFt": "Ancho (ft)",
        "heightFt": "Altura (ft)"
      },
      "notAvailable": "N/D",
      "addButton": "Añadir",
      "searchPlaceholder": "Buscar tipo de obstáculo por nombre",
      "messages": {
        "addSuccess": "{{obstacleName}} añadido a {{locationName}}",
        "addError": "No se pudo añadir {{obstacleName}}: {{errorMessage}}"
      }
    }
  },
  "addFBO": {
    "buttonLabel": "Añadir FBO",
    "dialogTitle": "Añadir un nuevo FBO",
    "instructions": "Crea un nuevo FBO e invita al primer usuario.",
    "successMessage": "Se ha enviado un correo a <b style=\"color: #3c6ce9\">{{email}}</b> con una invitación a <b style=\"color: #3c6ce9\">{{name}}</b>. También puede usar el enlace de abajo.",
    "nameLabel": "Nombre",
    "emailLabel": "Correo electrónico",
    "okButton": "OK",
    "cancelButton": "Cancelar",
    "addButton": "Agr."
  },
  "buttonMoveTo": {
    "assignTo": "Asignar a",
    "moveTo": "Mover a",
    "unassigned": "Sin asignar"
  },
  "buttonNotes": {
    "buttonText": "Notas"
  },
  "editTenant": {
    "dialogTitle": "Editar aeronave",
    "selectAircraftLabel": "Seleccionar aeronave",
    "duplicateTailWarning": "Número de cola duplicado",
    "ownerManagerLabel": "Propietario/Gerente",
    "notesLabel": "Notas",
    "notesPlaceholder": "Añadir notas sobre esta aeronave...",
    "lastUpdate": "Última actualización: {{time}} ({{date}}) por {{user}}",
    "typeLabel": "Tipo",
    "tenantOption": "Inquilino",
    "transientOption": "Tránsito",
    "yellowCardLabel": "Tarjeta Amarilla (YC)",
    "unassignedText": "Sin asignar",
    "naText": "N/D",
    "notHangaredText": "No en hangar",
    "confirmTitle": "Confirmar",
    "transientConfirmText": "Convertir este inquilino base en transitorio significa que esta aeronave ya no estará basada en sus hangares. Permanecerá en su lista de aeronaves transitorias.",
    "transient": "Tránsito",
    "base": "Base",
    "cancelButton": "Cancelar",
    "saveButton": "Guardar",
    "insufficientPermissionTitle": "Permiso insuficiente",
    "insufficientPermissionText": "Permiso insuficiente para modificar un arrendatario base. Actualmente tienes el rol de <u>{{roleName}}</u>. Necesitas ser <u>FBO Admin</u> o <u>Manager</u> para modificar un arrendatario base. Contacta a tu administrador de AirPlx si crees que esto es un error."
  },
  "aircraftSpecsTooltip": {
    "heightLabel": "H: {{height}}"
  },
  "fboMenu": {
    "switchFBO": "Cambiar FBO",
    "noFBOTitle": "No se encontró FBO",
    "noFBOMessage": "Actualmente no perteneces a un FBO. Contacta a tu administrador del sistema para unirte a uno.",
    "okButton": "OK"
  },
  "buttonUploadImage": {
    "compressingMessage": "Comprimiendo imagen. Esto tomará unos segundos."
  },
  "selectDumpTo": {
    "label": "A:",
    "holdingArea": "Área de espera",
    "frontOfHangar": "Frente del hangar"
  },
  "locationTextField": {
    "unassigned": "Sin asignar",
    "ramp": "Rampa",
    "hangar": "Hangar",
    "assignedLabel": "Asignado {{locationType}}",
    "currentLabel": "Actual {{locationType}}"
  },
  "aircraftListItem": {
    "tenant": "Inquilino",
    "transient": "Tránsito",
    "yc": "YC",
    "noseIn": "Nariz int",
    "tailIn": "Cola entra",
    "front": "Frontal",
    "back": "Volver",
    "okOutside": "OK Exterior",
    "locked": "Bloqueado"
  },
  "timelineAircraftList": {
    "title": "Cronología",
    "aircraftCount": "{{count}} aeronaves",
    "filterPlaceholder": "Filtrar...",
    "searchPlaceholder": "Buscar matrícula en todos los viajes...",
    "countOfTotal": "{{filtered}} de {{total}}",
    "totalAndHere": "{{total}} en total • {{here}} aquí",
    "filteredAndHere": "{{filtered}} de {{total}} • {{filteredHere}} aquí",
    "noAircraftFound": "No se encontró ninguna aeronave con matrícula \"{{tailNumber}}\"",
    "createNewTrip": "Crear nuevo viaje"
  },
  "multiHangarSelect": {
    "selectAll": "Selec. todo",
    "cancel": "Cancelar",
    "ok": "OK"
  },
  "timelineAircraftListItem": {
    "cancelled": "CANCELADO",
    "here": "AQUÍ",
    "hereNow": "AQUÍ AHORA",
    "unassigned": "Sin asignar",
    "unassignedStatus": "SIN ASIGNAR",
    "atLocation": "EN {{locationName}}",
    "arrivesInHours": "LLEGA EN {{hours}}H",
    "arrivesInDays": "LLEGA EN {{days}}D",
    "unknownAircraft": "Aeronave desconocida"
  },
  "aircraftPreferencesMenu": {
    "tailIn": "Cola entra",
    "noseIn": "Nariz int",
    "frontRow": "Primera fila",
    "backRow": "Fila trasera",
    "okOutside": "OK Exterior",
    "locked": "Bloqueado",
    "incrementalPark": "Parqueo incremental",
    "editAircraft": "Editar aeronave",
    "removeAircraft": "Eliminar aeronave",
    "removeObstacle": "Eliminar obstáculo",
    "confirmRemove": "Sí, eliminar esta aeronave",
    "confirmTitle": "Confirmar",
    "confirmTextReference": "Convertir este inquilino en transitorio significa que esta aeronave ya no estará basada en sus hangares. Permanecerá en su lista de aeronaves transitorias.",
    "confirmTextRemove": "Este avión será eliminado de este {{locationType}}.",
    "hangar": "hangar",
    "ramp": "rampa"
  },
  "aircraftActionMenu": {
    "noActiveTripWarning": "No se encontró ningún viaje activo o próximo para esta aeronave",
    "tripDetailsNotFound": "No se encontraron los detalles del viaje",
    "assignedForEntireTrip": "{{tailNumber}} asignado a {{locationName}} durante todo el viaje",
    "failedAssignEntireTrip": "Error al asignar el viaje completo",
    "assigned": "{{tailNumber}} asignado a {{locationName}}",
    "failedAssignAircraft": "Error al asignar aeronave",
    "jumpTo": "Ir a...",
    "assignHere": "Asignar aquí",
    "assignHereEntireTrip": "Asignar aquí (viaje completo)",
    "failedLoadTrips": "No se pudieron cargar los viajes de esta aeronave",
    "viewTrips": "Ver Viajes",
    "hereAt": "— Aquí en {{locationName}} —",
    "hoursStay": "{{hours}}h de estadía",
    "otherLocations": "— Otras ubicaciones —",
    "andMoreAt": "...y {{count}} más en {{locationName}}",
    "todayAt": "Hoy a las {{time}}",
    "tomorrowAt": "Mañana a las {{time}}",
    "yesterdayAt": "Ayer a las {{time}}",
    "inDaysAt": "En {{days}} días a las {{time}}"
  },
  "bulkActionToolbar": {
    "tripsSelected": "{{count}} viaje seleccionado",
    "selectLocation": "Seleccionar ubicación...",
    "assign": "Asignar",
    "unassign": "Desasignar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "clear": "Borrar"
  },
  "scheduledAircraftContextMenu": {
    "confirmTitle": "Confirmar",
    "confirmRemoveText": "Esto eliminará la aeronave de la programación en este horario.",
    "confirmRemoveButton": "Sí, eliminar de la programación",
    "missingDataError": "Faltan datos requeridos para el cambio de ubicación",
    "conflictError": "Otra aeronave ya está en esta ubicación en este horario",
    "gapError": "No se pueden crear huecos en la programación",
    "updateLocationError": "No se pudo actualizar la ubicación",
    "loadTripsError": "No se pudieron cargar los viajes de esta aeronave",
    "viewTrips": "Ver Viajes",
    "unlock": "🔓 Desbloquear",
    "lock": "🔒 Bloq.",
    "tailIn": "Cola entra",
    "noseIn": "Nariz int",
    "frontRow": "Primera fila",
    "backRow": "Fila trasera",
    "okOutside": "OK Exterior",
    "locked": "Bloqueado",
    "moveTo": "Mover a",
    "editAircraft": "Editar aeronave",
    "removeAircraft": "Eliminar aeronave",
    "unassigned": "Sin asignar"
  },
  "addTenantButton": {
    "tooltipAddTrip": "Añadir viaje",
    "tooltipAddAircraft": "Añadir aeronave",
    "buttonAddTrip": "Añadir viaje",
    "buttonAddAircraft": "Añadir aeronave",
    "dialogTitleAddTrip": "Añadir viaje",
    "dialogTitleAddAircraft": "Añadir aeronave",
    "tabs": {
      "newAircraft": "Nuevo avión",
      "priorTransients": "Transitorios anteriores",
      "tenants": "Inquilinos",
      "bulkAdd": "Añadir lote",
      "addTrip": "Añadir viaje",
      "allTrips": "Todos viajes",
      "bulkUpload": "Carga masiva",
      "addMovableObstacle": "Añadir obstáculo móvil"
    },
    "buttons": {
      "cancel": "Cancelar",
      "add": "Añadir",
      "createTrip": "Crear viaje",
      "creating": "Creando...",
      "saveTrips": "Guardar viajes",
      "saving": "Guardando...",
      "done": "Listo"
    },
    "notifications": {
      "addedToLocation": "{{model}} añadido a {{locationName}}",
      "added": "{{model}} añadido",
      "tryAutostack": "¡Prueba AutoStack para ver tu nueva aeronave en acción!",
      "runAutostack": "Ejecutar AutoStack"
    },
    "confirmTitle": "Confirmar",
    "confirmHangar": "Asignaremos este nuevo Inquilino Base a este hangar. Si necesita cambiar las asignaciones de hangar predeterminadas, puede hacerlo editando esta aeronave específica.",
    "confirmRamp": "Asignaremos este nuevo inquilino de amarre a esta plataforma. Si necesita cambiar las asignaciones de plataforma predeterminadas, puede hacerlo editando esta aeronave específica."
  },
  "viewSettings": {
    "buttonText": "Ver configuración",
    "locationNotAvailable": "Ubicación no disponible",
    "tugUpdatedSuccess": "Tug actualizado para {{locationName}}",
    "tugUpdateError": "Error al actualizar el tractor",
    "tailNumberTooltip": "Mostrar matrícula en la aeronave",
    "tailNumberLabel": "Matrícula",
    "notesTooltip": "Para ver una nota o todas las notas, ve a Configuración > Configuración",
    "notesLabel": "Notas",
    "modelTooltip": "Mostrar modelo de aeronave en aeronave",
    "modelLabel": "Modelo",
    "footprintTooltip": "Mostrar envergadura y longitud en la aeronave seleccionada",
    "footprintLabel": "Dimensiones",
    "sopSpacingTooltip": "Contorno de espaciado horizontal",
    "sopSpacingLabel": "Espaciado SOP",
    "wallSpacingTooltip": "Áreas de relleno visual de espaciado de pared",
    "wallSpacingLabel": "Relleno espaciado pared",
    "bayBoundariesTooltip": "Mostrar límites de bahías para hangares con alero escalonado",
    "bayBoundariesLabel": "Límites de bahía",
    "overlapsTooltip": "Resalta todas las superposiciones, no evalúa la seguridad del espaciado vertical",
    "overlapsLabel": "Traslapes",
    "coPilotTooltip": "Selecciona aeronaves no apiladas y obtén opciones conformes con SOP",
    "coPilotLabel": "Copiloto",
    "tugLabel": "Tug",
    "useFBODefault": "Usar predeterminado del FBO ({{defaultTugName}})",
    "spotsTooltip": "Mostrar lugares en plataforma",
    "spotsLabel": "Puestos",
    "rampImageTooltip": "Superponer imagen satelital de plataforma",
    "rampImageLabel": "Img plataforma",
    "zoneHeatmapTooltip": "Mostrar mapa de calor de ocupación por zona (próximas {{hours}}h)",
    "zoneHeatmapLabel": "Mapa de calor",
    "hours24": "24h",
    "hours72": "72h",
    "week1": "1s",
    "none": "Ning."
  },
  "currentAircraft": {
    "title": "Aeronave actual"
  },
  "layout": {
    "permissionDenied": {
      "modifyLayout": "No tienes permiso para modificar el diseño"
    },
    "deleteConfirmation": {
      "confirmAircraft": "Confirmar aeronave",
      "confirmObstacle": "Confirmar obstáculo",
      "removeAircraft": "Eliminar aeronave",
      "removeObstacle": "Eliminar obstáculo",
      "removeTransient": "Eliminar Transiente",
      "title": "Confirmar eliminación"
    }
  }
}
